import React, { useState } from "react";
import { Table, Button, Form, Modal } from "react-bootstrap";
import { FaPen } from "react-icons/fa";

const WebTranslations = ({ onBack }) => {
  const [showModal, setShowModal] = useState(false);

  const data = [
    { name: "Employees", total: 1620, complete: 1296, progress: 100, color: "green" },
    { name: "Clients", total: 1620, complete: 972, progress: 70, color: "pink" },
    { name: "Projects", total: 1620, complete: 810, progress: 40, color: "purple" },
    { name: "Tasks", total: 1620, complete: 324, progress: 60, color: "cyan" },
  ];

  return (
    <div className="web-translation-page">
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <h6>Language</h6>

        <div className="d-flex align-items-center gap-2 flex-wrap">
          <Button className="btn-orange" onClick={onBack}>
            ← Back to Translations
          </Button>

          <div className="lang-badge">
            🇦🇪 Arabic
          </div>
        </div>
      </div>

      {/* TABLE */}
      <Table responsive className="align-middle module-table">
        <thead>
          <tr>
            <th></th>
            <th>Module Name</th>
            <th>Total</th>
            <th>Complete</th>
            <th>Progress</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {data.map((item, i) => (
            <tr key={i}>
              <td><Form.Check /></td>

              <td className="fw-medium">{item.name}</td>

              <td>{item.total}</td>

              <td>{item.complete}</td>

              <td>
                <div className="progress-wrapper">
                  <div
                    className={`progress-bar-custom ${item.color}`}
                    style={{ width: `${item.progress}%` }}
                  />
                </div>
                <span className="ms-2">{item.progress}%</span>
              </td>

              <td>
                <Button
                  size="sm"
                  variant="light"
                  onClick={() => setShowModal(true)}
                >
                  <FaPen />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* ================= MODAL ================= */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Language</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>
              Module Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select>
              <option>Employees</option>
              <option>Clients</option>
              <option>Projects</option>
              <option>Tasks</option>
            </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Label>
              Language <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select>
              <option>English</option>
              <option>Arabic</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button className="btn-orange">
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      <style>
          {

               `
               .web-translation-page h6 {
  font-weight: 600;
}

/* Badge */
.lang-badge {
  border: 1px solid #ddd;
  padding: 6px 12px;
  border-radius: 6px;
  background: #fff;
  font-size: 14px;
}

/* Table */
.module-table th {
  background: #f5f5f5;
  font-weight: 600;
}

/* Progress */
.progress-wrapper {
  width: 150px;
  height: 6px;
  background: #eee;
  border-radius: 10px;
  display: inline-block;
  overflow: hidden;
}

.progress-bar-custom {
  height: 100%;
  border-radius: 10px;
}

/* Colors */
.progress-bar-custom.green {
  background: #28a745;
}

.progress-bar-custom.pink {
  background: #ff4081;
}

.progress-bar-custom.purple {
  background: #9c27b0;
}

.progress-bar-custom.cyan {
  background: #00bcd4;
}

/* Buttons */
.btn-orange {
  background: #ff6a00;
  border: none;
  color: #fff;
}

.btn-orange:hover {
  background: #e65c00;
}

/* Modal */
.modal-content {
  border-radius: 8px;
}

/* Mobile */
@media (max-width: 768px) {
  .progress-wrapper {
    width: 100px;
  }

  .module-table {
    font-size: 12px;
  }
}`
          }
      </style>
    </div>
  );
};

export default WebTranslations;